module.exports = __webpack_public_path__ + "img/nodeBackgroundDrawHorizontal.704d250d.svg";